export const communicationsDashboardPageRootUrl = '/dashboard';

export const commsActivitySubPageUrl = `/comms-activity`;
export const commsActivityFeaturedConversationsSubPageUrl = `/comms-activity/featured-conversations`;
export const digitalSafetySubPageUrl = `/advanced-moderation`;
export const leadersAndAudiencesSubPageUrl = `/leaders-and-audiences`;
export const leadersActivityLogSugPageUrl = `/leaders-and-audiences/activity-log`;
export const conversationsSugPageUrl = `/conversations`;

const projectIdParam = ':projectId';
export const projectsSubPageUrl = `/projects`;
export const projectSubPageUrl: string = `${projectsSubPageUrl}/${projectIdParam}`;
export const projectDetailsPage: string = `${communicationsDashboardPageRootUrl}${projectsSubPageUrl}/${projectIdParam}`;

export const projectOverviewSubPageUrl: string = `/overview`;
export const projectTeamSubPageUrl: string = `/team`;
export const projectAnalyticsSubPageUrl: string = `/analytics`;

export const corpCommsProjectOverviewPageUrl = (projectId: string): string =>
  `${communicationsDashboardPageRootUrl}${projectSubPageUrl}${projectOverviewSubPageUrl}`.replace(
    projectIdParam,
    projectId
  );
export const corpCommsProjectTeamPageUrl = (projectId: string): string =>
  `${communicationsDashboardPageRootUrl}${projectSubPageUrl}${projectTeamSubPageUrl}`.replace(
    projectIdParam,
    projectId
  );
export const threadIdParam = 'threadId';

export const corpCommsProjectAnalyticsPageUrl = (projectId: string, conversationThreadId?: string): string => {
  const path = `${communicationsDashboardPageRootUrl}${projectSubPageUrl}${projectAnalyticsSubPageUrl}`.replace(
    projectIdParam,
    projectId
  );

  return conversationThreadId == null ? path : `${path}?${threadIdParam}=${encodeURIComponent(conversationThreadId)}`;
};

export const communicationsDashboardPageUrl: string = `${communicationsDashboardPageRootUrl}${commsActivitySubPageUrl}`;
export const communicationsDashboardFeaturedConversationsUrl: string = `${communicationsDashboardPageRootUrl}${commsActivityFeaturedConversationsSubPageUrl}`;
export const communicationsDashboardDigitalSafetyPageUrl: string = `${communicationsDashboardPageRootUrl}${digitalSafetySubPageUrl}`;
export const communicationsDashboardLeadersAndAudiencesPageUrl: string = `${communicationsDashboardPageRootUrl}${leadersAndAudiencesSubPageUrl}`;
export const communicationsDashboardLeadersActivityLogPageUrl: string = `${communicationsDashboardPageRootUrl}${leadersActivityLogSugPageUrl}`;
export const communicationsDashboardConversationsPageUrl: string = `${communicationsDashboardPageRootUrl}${conversationsSugPageUrl}`;
export const communicationsDashboardProjectsPageUrl: string = `${communicationsDashboardPageRootUrl}${projectsSubPageUrl}`;
